import axios from "axios";

const API = axios.create({ baseURL: "https://lqms.onrender.com/api" });
// const API = axios.create({ baseURL: "http://localhost:10000/api" });

// Add a request interceptor
API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken"); // Retrieve the token from local storage
    if (token) {
      config.headers.Authorization = `Bearer ${token}`; // Set the token in the Authorization header
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle token expiration
API.interceptors.response.use(
  (response) => response, 
  (error) => {
    if (error.response && error.response.status === 403) {
      // Token expired or unauthorized
      localStorage.removeItem("authToken"); 
      window.location.href = "/"; 
    }
    return Promise.reject(error);
  }
);

// user api's start

export const login = (userId, password) =>
  API.post("/users/login", userId, password);
export const validateUserId = (userId) => API.post("/users/validate-user-id", { userId });
export const validatePassword = (userId,password) => API.post("/users/validate-password", { userId,password });
export const resetPassword = (data) => API.post("/users/password", data);
export const getUsers = async () => API.get("/users");
export const getUserById = async (id) => API.get(`/users/${id}`);
export const createUser = async (userData) => API.post("/users/register", userData);
export const updateUser = async (id, userData) => API.put(`/users/${id}`, userData);
export const deleteUser = async (id) => API.delete(`/users/${id}`);
export const sentOtp = async (emailData) => API.post(`/users/sentOtp`, emailData);
export const verifyOtp = async (verifyOtpData) => API.post(`/users/verifyOtp`, {verifyOtpData});
export const forgotPassword = async (verifyPasswordData) => API.post(`/users/newPassword`, {verifyPasswordData});
//user api's ended

// items api's start

export const addItem = (
  itemId,
  itemName,
  item_quantity,
  item_cost,
  orgId,
  isActive,
  createdBy,
  updatedBy
) =>
  API.post(
    "/items/add",
    itemId,
    itemName,
    item_quantity,
    item_cost,
    orgId,
    isActive,
    createdBy,
    updatedBy
  );

export const fetchItems = () => API.get("/items");
export const fetchItemsByOrgId = (orgId) => API.get(`/items/${orgId}`);
export const fetchItemByBillId =(billId)=>API.get(`/items/getItems/${billId}`) 
export const updateItem = (itemName,billId,orgId, updatedData) =>
  API.put(`/items/${itemName}/${billId}/${orgId}`, updatedData);
export const deleteItem = (itemName,billId,orgId) => API.delete(`/items/${itemName}/${billId}/${orgId}`);
//items api's ended

//sold item api's start

export const addSoldItemScanned = (scannedItems) => 
  API.post("/soldItems/", {scannedItems});

export const addSoldItemManually = (
  sold_itemId,
  itemId,
  itemName,
  sold_stockQuantity, 
  sold_cost,
  soldCreatedBy,
  orgId,
  quantity_ml,
  soldCreatedAt,
  
) => 
  API.post("/soldItems/Manually", {
    sold_itemId,
    itemId,
    itemName,
    sold_stockQuantity: Number(sold_stockQuantity), 
    sold_cost: Number(sold_cost), 
    soldCreatedBy,
    orgId,
    quantity_ml: Number(quantity_ml), 
    soldCreatedAt,
   
  });

export const fetchSoldItemById = (orgId) => API.get(`/soldItems/${orgId}`); 
export const fetchSoldItemByBillId = (billId) => API.get(`/soldItems/getSoldItemsByBillId/${billId}`)
export const fetchSoldItemsByDateRange = (startDate, endDate, orgId) => 
  API.post(`/soldItems/${orgId}/sold-items-by-date-range`, { startDate, endDate, orgId });

//sold items api's ended

// Bill api's start
export const CreateBill =(formData)=> API.post(`/bill/add`,formData)
export const getAllBillByOrgId =(orgId) =>API.get(`/bill/${orgId}`)
export const updateBillDetails = (id, updatedData) =>
  API.put(`/bill/${id}`, updatedData);

export const deleteBillDetails = (id) =>
  API.delete(`/bill/${id}`);

// Bill api's end

// itemList api's start
export const CreateItem = (itemData) => API.post(`/itemList/`, itemData);
export const itemList = (orgId) => 
  API.get(`/itemList/${orgId}`);
export const getAllItemListByOrgId =(orgId) => API.get(`/itemList/${orgId}`);
export const getAllItemListByBarCode =(barCode) => API.get(`/itemList/barCode/${barCode}`);
export const updateItemDetails = (itemsName, itemsUnits, issuePrice, mrp, itemId,orgId) =>
  API.put(`/itemList/${itemsName}/${itemsUnits}`, { issuePrice, mrp, itemId,orgId });
export const updateBulkItems = (bulkData) =>
  API.put(`/itemList/bulkItmeUpdate`, bulkData);
export const deleteItemDetails = (itemsName, itemsUnits, itemId,orgId) =>
  API.delete(`/itemList/${itemsName}/${itemsUnits}`, {
    data: { itemId,orgId },
  });
  export const updateSodlItemAtsingSoldItemAndsoldItem = (updatedData) => API.put(`/soldItems/updateSoldItems`,updatedData);


//itemList api's ended

// single sold items api's start
export const getSingleSoldCountByItemNameandBillId = (itemName, billId) =>
  API.get(`/singleSoldItem/total-sold-count`, { params: { itemName, billId } });

export const deleteSingleSoldItem = (data) => 
  API.delete(`/singleSoldItem/delete-item`, { data });

//single sold items api's ended

//Payments Start

export const getAllPayments = async () => API.get(`/lqmsPayments/payments`);
export const updatePayment = async (id, updatedData) => API.put(`/lqmsPayments/payments/${id}`, updatedData);
export const createPayment = async (paymentData) => API.post(`/lqmsPayments/payments`, paymentData);

//Payments end
